export const Sidebar = ({ items, currentId, onChange }: {
  items: API.PROJECTHQ_NEW.Item[]
  currentId?: number
  onChange: (item: API.PROJECTHQ_NEW.Item) => void
}) => <aside className="w-52 shrink-0 py-4 pr-4 space-y-2 overflow-y-auto">
  {items.map(item => <button key={item.id} aria-pressed={item.id === currentId} onClick={() => onChange(item)}
    className={`w-full text-left flex justify-between items-center gap-2 p-3 rounded-lg ${item.id === currentId ? "bg-blue-100 text-blue-700 font-semibold" : "text-gray-600 hover:bg-gray-100"}`}>
    <span>{item.name}</span>
    {item.uncompletedCount > 0 && <span className="text-xs bg-gray-200 text-gray-600 rounded-full px-2">{item.uncompletedCount}</span>}
  </button>)}
</aside>
